module.exports = __webpack_public_path__ + "img/mzxwooribank.cc0da022.png";